import { type TeamMemberUpdateInput, type TeamMemberUpdateSuccess, toResponseError } from '@terros/common'
import { applyRoleIdChange } from '../user/listRoles'
import { useUserCache } from '../user'
import { useTeamCache } from '../team'
import { useRoleCache } from '../role'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'

export function useUpdateTeamMember(): UpdateHookResponse<TeamMemberUpdateInput, TeamMemberUpdateSuccess> {
  const cache = useTeamCache()
  const userCache = useUserCache()
  const roleCache = useRoleCache()
  const mutation = useTantalimMutation<TeamMemberUpdateInput, TeamMemberUpdateSuccess>({
    url: '/team/member/update',
  })

  async function update(input: TeamMemberUpdateInput): Promise<TeamMemberUpdateSuccess> {
    try {
      const output = await mutation.mutateAsync(input)
      cache.updateMembership(input)
      userCache.clearItem(input.userId)
      userCache.syncListedRoles(input.userId, (roles) =>
        applyRoleIdChange({
          roles,
          nextRoleIds: input.roleIds,
          resolveRole: roleCache.findTinyRole,
        })
      )
      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
